import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from 'primevue/config';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';


const app = createApp(App);


app.mount("#app");
app.use(PrimeVue, {
    inputStyle: 'filled',
    locale: {
        today: 'Heute',
        dayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
        dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    monthNames: ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],
    dateFormat: 'dd.mm.yy'
    }
});

1